export const EventNames = [
    "abort",
    "activate",
    "beforeactivate",
    "beforecopy",
    "beforecut",
    "beforedeactivate",
    "beforepaste",
    "blur",
    "canplay",
    "canplaythrough",
    "change",
    "click",
    "contextmenu",
    "copy",
    "cuechange",
    "cut",
    "dblclick",
    "deactivate",
    "drag",
    "dragend",
    "dragenter",
    "dragleave",
    "dragover",
    "dragstart",
    "drop",
    "durationchange",
    "emptied",
    "ended",
    "error",
    "focus",
    "input",
    "invalid",
    "keydown",
    "keypress",
    "keyup",
    "load",
    "loadeddata",
    "loadedmetadata",
    "loadstart",
    "mousedown",
    "mouseenter",
    "mouseleave",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "mousewheel",
    "MSContentZoom",
    "MSManipulationStateChanged",
    "paste",
    "pause",
    "play",
    "playing",
    "progress",
    "ratechange",
    "reset",
    "scroll",
    "seeked",
    "seeking",
    "select",
    "selectstart",
    "stalled",
    "submit",
    "suspend",
    "timeupdate",
    "volumechange",
    "waiting",
    "ariarequest",
    "command",
    "gotpointercapture",
    "lostpointercapture",
    "MSGestureChange",
    "MSGestureDoubleTap",
    "MSGestureEnd",
    "MSGestureHold",
    "MSGestureStart",
    "MSGestureTap",
    "MSGotPointerCapture",
    "MSInertiaStart",
    "MSLostPointerCapture",
    "MSPointerCancel",
    "MSPointerDown",
    "MSPointerEnter",
    "MSPointerLeave",
    "MSPointerMove",
    "MSPointerOut",
    "MSPointerOver",
    "MSPointerUp",
    "touchcancel",
    "touchend",
    "touchmove",
    "touchstart",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
    "pointercancel",
    "pointerdown",
    "pointerenter",
    "pointerleave",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "wheel",
    "animationend",
    "animationEnd",
    "webkitAnimationEnd",
    "mozAnimationEnd",
    "msAnimationEnd",
    "oAnimationEnd",
    "transitionend",
    "transitionEnd",
    "webkitTransitionEnd",
    "mozTransitionEnd",
    "msTransitionEnd",
    "oTransitionEnd"
];
